import { dataPlayCircleSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconPlayCircleSolid = /*#__PURE__*/createIcon(dataPlayCircleSolid)
export default IconPlayCircleSolid
